import { SOCIAL_PROVIDERS } from 'constants/registration';
import {
  CreatorPortfolio,
  InfluencerPortfolio,
  SocialLink,
} from 'types/creator';
import { isSocialProvider } from 'types/profile';
import { alternateArrays } from './array';

export const socialRecordToLinks = (
  socials: Partial<Record<SOCIAL_PROVIDERS, string>> = {}
) =>
  Object.keys(socials)
    .map((social) => {
      const url = socials[social as SOCIAL_PROVIDERS];
      if (
        !isSocialProvider(social) ||
        typeof url === 'undefined' ||
        url === ''
      ) {
        return null;
      }
      return { url, social };
    })
    .filter((record) => record) as Array<SocialLink>;

export const getCreatorReferralUrl = (
  creatorId: string,
  utmSource = 'trend',
  utmMedium = 'creator profile'
) => {
  creatorId = encodeURIComponent(creatorId);
  utmSource = encodeURIComponent(utmSource);
  utmMedium = encodeURIComponent(utmMedium);
  return `https://app.trend.io/?utm_source=${utmSource}&utm_medium=${utmMedium}&utm_campaign=${creatorId}`;
};

export const influencerPortfolioToCreatorPortfolio = (
  portfolio: InfluencerPortfolio
): CreatorPortfolio => {
  const { photos = [], videos = [] } = portfolio;
  const photoMediaItems: CreatorPortfolio = photos.reverse().map((url) => ({
    type: 'image',
    url,
  }));
  const videoMediaItems: CreatorPortfolio = videos.reverse().map((url) => ({
    type: 'video',
    url,
  }));
  return alternateArrays(photoMediaItems, videoMediaItems);
};
